export const FIND_PROVISIONING = 'OVID/PROVISIONING/FIND_PROVISIONING'
export const FIND_PROVISIONING_SUCCESS = 'OVID/PROVISIONING/FIND_PROVISIONING_SUCCESS'
export const FIND_PROVISIONING_FAILED = 'OVID/PROVISIONING/FIND_PROVISIONING_FAILED'
export const FIND_PROVISIONING_RESET = 'OVID/PROVISIONING/FIND_PROVISIONING_RESET'
